import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FiAlertOctagon } from "react-icons/fi";
import { formatToReal } from "../../../utils/utils";

const AvisoCard = ({
  hasRestrictions,
  title,
  messageError,
  messageSuccess = "Nada consta",
  value = 0,
}) => {
  const isPositive = !hasRestrictions;

  return (
    <div className="w-full border rounded-lg bg-white shadow-sm p-5 flex flex-col gap-3">
      {/* Header */}
      <div className="flex items-center gap-3">
        <div className="flex items-center justify-center w-9 h-9 rounded-full bg-gray-100">
          {isPositive ? (
            <IoMdCheckmarkCircleOutline className="text-green-600" size={20} />
          ) : (
            <FiAlertOctagon className="text-red-600" size={20} />
          )}
        </div>
        <h3
          className={`text-base font-semibold ${
            isPositive ? "text-gray-800" : "text-red-800"
          }`}
        >
          {title}
        </h3>
      </div>

      {/* Mensagem */}
      <div
        className={`text-sm leading-relaxed rounded-md px-4 py-2 font-medium ${
          isPositive
            ? "bg-gray-50 text-gray-700 border border-gray-200"
            : "bg-red-50 text-red-800 border border-red-200"
        }`}
      >
        {isPositive ? messageSuccess : messageError}
      </div>
    </div>
  );
};

export default AvisoCard;
